import React from 'react'
import "react-datepicker/dist/react-datepicker.css";

function EditRole({ RoleData, sendDataToParent }) {

  function handleChange(e) {
    const { name, type, checked, value } = e.currentTarget;
    sendDataToParent((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  return (
    <>
      <div className="row">
        <div className="mb-3">
          <label className="form-label">Role Name <span style={{ color: "red" }}>*</span></label>
          <input
            type="hidden"
            name="RoleId"
            value={RoleData.RoleId ?? ""}
          />
          <input
            type="text"
            className="form-control"
            name="RoleName"
            value={RoleData.RoleName ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Normalized Name</label>
          <input
            type="text"
            className="form-control"
            name="NormalizedName"
            value={RoleData.NormalizedName ?? ""}
            onChange={handleChange}
          />
        </div>

        {/* Admin Rights Checkbox */}
        <div className="col-lg-12">
          <div className="form-check mb-3">
            <input
              type="checkbox"
              className="form-check-input"
              id="HasAdminRights"
              name="HasAdminRights"
              checked={!!RoleData.HasAdminRights}
              onChange={handleChange}
            />
            <label className="form-check-label" htmlFor="HasAdminRights">
              Has Admin Rights
            </label>
          </div>
        </div>
      </div>
    </>
  )
}

export default EditRole